<script>
import NoContentPlaceholder from "../../../theme/organisms/NoContentPlaceholder.vue";
import NoContentPlaceholderCustom from "../../../theme/organisms/NoContentPlaceholderCustom.vue";
import ListProvider from "../../../theme/molecules/ListProvider.vue";
import {FORM_STATUS} from "../services/SpaceFormConstants";
import ShareModal from "./ShareModal.vue";
import ShareFormByLink from "../molecules/ShareFormByLink.vue";
import SubmissionItem from "../atoms/SubmissionItem.vue";
import ViewSubmissionModal from "./ViewSubmissionModal.vue";

export default {
    name: "FormSubmissions",
    components: {
        ViewSubmissionModal,
        SubmissionItem,
        ShareFormByLink,
        ShareModal,
        ListProvider,
        NoContentPlaceholder,
        NoContentPlaceholderCustom
    },
    props: {
        value: {
            type: Object,
            required: true
        },
        title: {
            type: String,
            required: false
        },
        shareButton: {
            type: Boolean,
            required: false,
            default: true,
        },
        viewAllBtn: {
            type: Boolean,
            required: false,
            default: false,
        },
        status: {
            type: String,
            required: false,
            default: 'any',
        },
        classes: {
            type: String,
            required: false,
            default: ''
        }
    },
    watch: {
        model: {
            handler() {
                this.$emit('input', this.model)
            },
            deep: true
        },
        total() {
            this.$emit('total-changed', this.total)
        }
    },
    data() {
        return {
            model: this.value,
            submittingAction: null,
            FORM_STATUS,
            total: 0,
            submission: {},
            formStatus: this.status,
        }
    },
    methods: {
        async changeStatus(status) {
            this.submittingAction = status;
            const preset = this.model.preset;
            const {data} = await axios.post(`/space/forms/${this.model?.id}/change-status`, {status});
            this.model = {...data.data, preset};
            this.$notify({type: 'success', text: trans('general.page.space_forms.messages.form_updated')});
            this.submittingAction = null;
        },
        openModal() {
            this.$refs.shareModal.open();
        },
        openViewForm(submission) {
            this.submission = submission;

            this.$refs.viewSubmissionModal.open({...this.submission});
        },
        handleModalClose() {
            this.submission = {};
            this.$refs.submissionsListProvider.reload();
        },
        getFormSubmissionsUrl(id) {
            if(id) {
                return `/space/forms/${id}/submissions`;
            } else {
                return `/space/forms/all/submissions`;
            }
        }
    },
}
</script>

<template>
    <div>
        <div class="mb-3 d-flex justify-content-between align-items-center">
            <div>
                <h5 v-if="title">{{ trans('general.component.side_bar.admissions') }}</h5>
            </div>
            <div>
                <basic-button cls="btn btn-open btn-secondary  mt-3" v-if="shareButton && total !== 0" @click="openModal"
                              :text="trans('general.defaults.share')"
                              icon="fi fi-rr-paper-plane" icon-position="right"></basic-button>

                <a v-if="viewAllBtn" href="/space/forms" class="d-flex align-items-center gap-2">
                    <i class="fi fi-rr-arrow-right"></i>
                    {{ trans('general.defaults.view_all') }}
                </a>
            </div>
        </div>

        <list-provider :url="getFormSubmissionsUrl(model.id)" :class="classes"
                       :params="{include: 'form', status: formStatus}"
                       v-on:total-changed="total = $event" wrap-class=""
                       :sort="{order_by: 'created_at', sorted_by: 'desc'}" :limit="12" ref="submissionsListProvider">
            <template #header>
                <div class="border-radius-20 item pl-0 d-none d-lg-block">
                    <div class="d-flex">
                        <div
                            class="d-flex text-center flex-column align-content-center px-2 justify-content-center"
                            style="border-radius: 7px 0 0 7px">
                            <i class="fi fi-rr-document px-2"></i>
                        </div>
                        <div class="d-lg-flex justify-content-between py-1 px-2 w-100 align-items-center">
                            <div class="col col-lg-4">
                                <h6 class="fs-16 fw-bold"> {{ trans('general.page.space_forms.submission.title') }}</h6>
                            </div>
                            <div class="col">
                                <div class="text-gray-500 fs-14">{{ trans('general.page.space_forms.submission.status') }}</div>
                            </div>
                            <div class="col">
                                <div class="text-gray-500 fs-14">{{ trans('general.page.space_forms.submission.created_at') }}</div>
                            </div>
                            <div class="col"></div>
                        </div>
                        <div class="d-lg-none py-1 px-2 w-100 d-flex justify-content-between"></div>
                    </div>
                </div>
            </template>
            <template #item="item">
                <submission-item :item="{...item}" class="mb-2" @open="openViewForm"></submission-item>
            </template>
            <template #noContent="list">
                <no-content-placeholder v-if="!Object.keys(list).length && model.status === FORM_STATUS.ACTIVE"
                icon="fi-rr-share"
                :text="trans('general.page.space_forms.messages.share_form_by_link')"
                :title="trans('general.page.space_forms.share_form_title')">
                    <template #custom>
                        <share-form-by-link v-model="model"></share-form-by-link>
                    </template>
                </no-content-placeholder>
                <no-content-placeholder v-else-if="!Object.keys(list).length && model.status === FORM_STATUS.DRAFT"
                                        image="/img/illustrations/items.png"
                                        :text="trans('general.page.space_forms.messages.activate_form')">
                    <template #action>
                        <basic-button cls="btn btn-success btn-lg mt-3"
                                      :loading="submittingAction === FORM_STATUS.ACTIVE"
                                      @click="changeStatus(FORM_STATUS.ACTIVE)"
                                      :text="trans('general.defaults.activate')" icon="fi fi-rr-check"
                                      icon-position="right"></basic-button>
                    </template>
                </no-content-placeholder>
            </template>
        </list-provider>
        <share-modal ref="shareModal" v-model="model"></share-modal>
        <view-submission-modal ref="viewSubmissionModal" @closed="handleModalClose"></view-submission-modal>
    </div>
</template>
